import React from "react";
import {I18n} from "react-redux-i18n";
import TextAreaField from "../../../shared/components/fields/textareaField/TextAreaField";
import PropTypes from "prop-types";

const TextConfigField = ({
    name,
    fieldConfig,
    value,
    handleOnFieldBlur,
    handleFieldChange,
}) => {
    return <div className="row">
        <TextAreaField
            value={value}
            label={I18n.t("dashboard.widgets.formsFields.text")}
            handleFieldChange={value => handleFieldChange(name, value)}
            handleFieldBlur={() => handleOnFieldBlur(name)}
            isRequired={fieldConfig.required}
            themeName="form"
            width={12}
        />
    </div>
};

TextAreaField.propTypes = {
    name: PropTypes.string,
    fieldConfig: PropTypes.object,
    value: PropTypes.string,
    handleOnFieldBlur: PropTypes.func,
    handleFieldChange: PropTypes.func,
};

export default TextConfigField;